module.exports = __webpack_public_path__ + "img/(per 1000 live births) (NHMIS - 2019) (1).988783b8.png";